import { useEffect, useState, useRef } from "react";
import { createTimelineCarousel } from "../Carousels";
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { Props_SnippetTimeline } from "./Timeline.props";

const SnippetTimeline = (props: Props_SnippetTimeline) => {
    const { heading, repeatable_timeprops } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // Pass the ref instead of just calling the function
        createTimelineCarousel(containerRef, setActiveIndex);
    }, []);

    return (
        <section className="snippet-timeline" id={heading?.snippetid?.value || ''}>
            <div className="snippet-timeline__container" ref={containerRef}>
                {heading?.content?.value && (
                    <div className="snippet-timeline__heading-container">
                        <h2 className="snippet-timeline__heading">{heading.content.value}</h2>
                    </div>
                )}
                <div className="snippet-timeline__content-container">
                    {repeatable_timeprops.map((item, index) => (
                        <div key={index} className="snippet-timeline__item">
                            <div className="snippet-timeline__year">{item.year?.value}</div>
                        </div>
                    ))}
                </div>
                <div className="snippet-timeline__body-container">
                    {repeatable_timeprops.map((item, index) => (
                        index === activeIndex && (
                            <div key={index} className="snippet-timeline__body">
                                <div className="snippet-timeline__text">
                                    {CompileMarkdown(item.content?.value || '')}
                                </div>
                            </div>
                        )
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetTimeline;